import { yupResolver } from "@hookform/resolvers/yup";
import LoadingFormNormal from "components/shared-components/LoadingFormNormal";
import MessageFormValidate from "components/shared-components/MessageFormValidate";
import { formConvertErrorMessage, formValidate } from "helpers/form_helper";
import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import InputMask from "react-input-mask";
import { useDispatch, useSelector } from "react-redux";
import Select from "react-select";
import { useToasts } from "react-toast-notifications";
import {
  Button,
  Col,
  FormGroup,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
} from "reactstrap";
import {
  createInvoiceSymbol,
  detailInvoiceSymbol,
  resetCreateInvoiceSymbol,
  resetDetailInvoiceSymbol,
  resetUpdateInvoiceSymbol,
  updateInvoiceSymbol,
} from "store/actions";
import * as yup from "yup";
import { KyHieuMauHoaDonMode, invoiceSymbolModeList } from "./utils";

const DetailInvoiceSymbol = props => {
  const { isOpenModal, dataDetail, toggleModal, mode, buCode } = props;
  const dispatch = useDispatch();
  const { t, i18n } = useTranslation(["invoiceSymbol"]);
  const { addToast } = useToasts();

  const invoiceSymbol = useSelector(state => state.invoiceSymbol);
  const {
    loadingDetail,
    errorDetail,
    detail: invoiceSymbolDetail,

    loadingCreate,
    errorCreate,
    create: invoiceSymbolCreate,

    loadingUpdate,
    errorUpdate,
    update: invoiceSymbolUpdate,
  } = invoiceSymbol;

  const [isDetail, setIsDetail] = useState(false); // Prevent To Set Data Again After Action Detail

  const [data_khmhd, setData_khmhd] = useState([]);

  const initFormFields = {
    khmhdon: undefined,
    bu_code: "",
    khhdon: "",
  };

  const initControlFields = {
    display: {
      bu_code: false,
      khmhdon: false,
      khhdon: false,
      btn_save: false,
    },
    disabled: {
      khmhdon: false,
      khhdon: false,
      is_pos: false,
      is_default: false,
    },
  };
  const [controlFields, setControlFields] = useState(initControlFields);

  const schema = yup.object().shape({
    bu_code: yup
      .string()
      .required(t("form.validate.required", { title: t("form.bu_code") }))
      .max(100, t("form.validate.char_max", { max: 100 })),
    khmhdon: yup
      .object()
      .required(t("form.validate.select", { title: t("form.khmhdon") })),
    khhdon: yup
      .string()
      .required(t("form.validate.required", { title: t("form.khhdon") }))
      .max(100, t("form.validate.char_max", { max: 100 }))
      .test(
        "len",
        "Vui lòng chỉ nhập 2 ký tự (A, B, C, D, E, G, H, K, L, M, N, P, Q, R, S, T, U, V, X, Y)",
        val => {
          return val.length === 2;
        }
      ),
  });

  const {
    handleSubmit,
    reset,
    formState: { errors, touchedFields, isSubmitting },
    control,
    setValue,
    getValues,
    setError,
    register,
    unregister,
    trigger,
  } = useForm({
    resolver: yupResolver(schema),
    mode: "all",
    reValidateMode: "onChange",
    defaultValues: { ...initFormFields },
  });

  // Modal Closed
  useEffect(() => {
    if (!isOpenModal) {
      setIsDetail(false);
      setControlFields(initControlFields);
      setData_khmhd([]);
      dispatch(resetDetailInvoiceSymbol());
    }
  }, [dispatch, isOpenModal]);

  // Action Detail
  useEffect(() => {
    if (isOpenModal) {
      if (dataDetail && !isDetail) {
        if (dataDetail.createInvoiceSymbol) {
          reset({ ...initFormFields });
          switch (mode) {
            case invoiceSymbolModeList.CREATE_INVOICE_SYMBOL_DETAIL:
              setValue("bu_code", buCode, { shouldValidate: true });

              convertData_khmhd();

              setControlFields({
                display: {
                  ...initControlFields.display,
                  bu_code: true,
                  khmhdon: true,
                  khhdon: true,
                  btn_save: true,
                },
                disabled: {
                  ...initControlFields.disabled,
                  bu_code: true,
                },
              });
              break;
            default:
              break;
          }
          setIsDetail(true);
        }

        if (dataDetail.invoiceSymbolId) {
          convertData_khmhd();
          dispatch(detailInvoiceSymbol(dataDetail.invoiceSymbolId));
          setIsDetail(true);
        }
      }
    }
  }, [dataDetail, dispatch, isDetail, isOpenModal]);

  // Set Data Detail
  useEffect(() => {
    if (isOpenModal) {
      if (invoiceSymbolDetail && invoiceSymbolDetail.success) {
        reset({});

        const dataReset = {};

        if (invoiceSymbolDetail.khmhdon) {
          dataReset["khmhdon"] = {
            value: invoiceSymbolDetail.khmhdon,
            label: `${invoiceSymbolDetail.khmhdon} - ${t(
              `khmhdon_list.${invoiceSymbolDetail.khmhdon}`
            )}`,
          };
        }

        switch (mode) {
          case invoiceSymbolModeList.VIEW_INVOICE_SYMBOL_DETAIL:
            reset({ ...initFormFields, ...dataReset });

            setValue("bu_code", invoiceSymbolDetail.bu_code);
            setValue("khhdon", invoiceSymbolDetail.khhdon);
            setValue("is_pos", invoiceSymbolDetail.is_pos ? true : false, {
              shouldValidate: true,
            });
            setValue(
              "is_default",
              invoiceSymbolDetail.is_default ? true : false,
              {
                shouldValidate: true,
              }
            );

            setControlFields({
              display: {
                ...initControlFields.display,
                bu_code: true,
                khmhdon: true,
                khhdon: true,
              },
              disabled: {
                ...initControlFields.disabled,
                bu_code: true,
                khmhdon: true,
                khhdon: true,
                is_pos: true,
              },
            });
            break;
          case invoiceSymbolModeList.EDIT_INVOICE_SYMBOL_DETAIL:
            reset({ ...initFormFields, ...dataReset });

            setValue("bu_code", invoiceSymbolDetail.bu_code, {
              shouldValidate: true,
            });
            setValue("khhdon", invoiceSymbolDetail.khhdon, {
              shouldValidate: true,
            });
            setValue("is_pos", invoiceSymbolDetail.is_pos ? true : false, {
              shouldValidate: true,
            });
            setValue(
              "is_default",
              invoiceSymbolDetail.is_default ? true : false,
              {
                shouldValidate: true,
              }
            );

            setControlFields({
              display: {
                ...initControlFields.display,
                bu_code: true,
                khmhdon: true,
                khhdon: true,
                btn_save: true,
              },
              disabled: {
                ...initControlFields.disabled,
                bu_code: true,
                khmhdon: true,
                is_default: false,
              },
            });
            break;
          default:
            break;
        }
        invoiceSymbolDetail.success = false;
      }
    }
  }, [invoiceSymbolDetail, isOpenModal, mode, reset, setValue]);

  // Action Dispatch
  useEffect(() => {
    if (isOpenModal) {
      if (invoiceSymbolCreate && invoiceSymbolCreate.success) {
        addToast(
          t("message.create", {
            target: t("invoice_symbol"),
            status: t("message.success"),
          }),
          {
            appearance: "success",
            autoDismiss: true,
          }
        );
        dispatch(resetCreateInvoiceSymbol());
        toggleModal(mode);
      }

      if (invoiceSymbolUpdate && invoiceSymbolUpdate.success) {
        addToast(
          t("message.update", {
            target: t("invoice_symbol"),
            status: t("message.success"),
          }),
          {
            appearance: "success",
            autoDismiss: true,
          }
        );
        dispatch(resetUpdateInvoiceSymbol());
        toggleModal(mode);
      }
    }
  }, [
    addToast,
    dispatch,
    invoiceSymbolCreate,
    invoiceSymbolUpdate,
    isOpenModal,
    mode,
    t,
    toggleModal,
  ]);

  // Error Dispatch
  useEffect(() => {
    if (isOpenModal) {
      if (errorDetail) {
        addToast(
          formConvertErrorMessage(
            errorDetail.message ||
              t("message.detail", {
                target: t("invoice_symbol"),
                status: t("message.error"),
              }),
            t
          ),
          {
            appearance: "error",
            autoDismiss: true,
          }
        );
        dispatch(resetDetailInvoiceSymbol());
      }

      if (errorCreate) {
        addToast(
          formConvertErrorMessage(
            errorCreate.message ||
              t("message.create", {
                target: t("invoice_symbol"),
                status: t("message.error"),
              }),
            t
          ),
          {
            appearance: "error",
            autoDismiss: true,
          }
        );

        if (errorCreate.code === 422 && errorCreate.fields.length > 0) {
          errorCreate.fields.map(item => {
            let fieldName = item.field;
            switch (item.field) {
              case "common":
                addToast(item.message, {
                  appearance: "error",
                  autoDismiss: true,
                });
                break;
              default:
                break;
            }
            setError(fieldName, {
              type: "manual",
              message: formConvertErrorMessage(item.message, t),
            });
          });
        }
        dispatch(resetCreateInvoiceSymbol());
        if (errorCreate.code !== 422) {
          toggleModal(mode);
        }
      }

      if (errorUpdate) {
        addToast(
          formConvertErrorMessage(
            errorUpdate.message ||
              t("message.update", {
                target: t("invoice_symbol"),
                status: t("message.error"),
              }),
            t
          ),
          {
            appearance: "error",
            autoDismiss: true,
          }
        );
        if (errorUpdate.code === 422 && errorUpdate.fields.length > 0) {
          errorUpdate.fields.map(item => {
            let fieldName = item.field;
            switch (item.field) {
              case "common":
                addToast(item.message, {
                  appearance: "error",
                  autoDismiss: true,
                });
                break;
              default:
                break;
            }
            setError(fieldName, {
              type: "manual",
              message: formConvertErrorMessage(item.message, t),
            });
          });
        }
        dispatch(resetUpdateInvoiceSymbol());
        if (errorUpdate.code !== 422) {
          toggleModal(mode);
        }
      }
    }
  }, [
    addToast,
    dispatch,
    errorCreate,
    errorDetail,
    errorUpdate,
    isOpenModal,
    mode,
    setError,
    t,
    toggleModal,
  ]);

  const onSubmit = values => {
    const { bu_code, khmhdon, khhdon, is_pos, is_default } = values;
    switch (mode) {
      case invoiceSymbolModeList.CREATE_INVOICE_SYMBOL_DETAIL:
        dispatch(
          createInvoiceSymbol({
            bu_code: bu_code,
            khmhdon: khmhdon.value,
            khhdon: khhdon,
            is_pos: is_pos ? 1 : 0,
            is_default: is_default ? 1 : 0,
          })
        );
        break;
      case invoiceSymbolModeList.EDIT_INVOICE_SYMBOL_DETAIL:
        dispatch(
          updateInvoiceSymbol(invoiceSymbolDetail.id, {
            khhdon: khhdon,
            is_default: is_default ? 1 : 0,
          })
        );
        break;
      default:
        break;
    }
  };

  const convertData_khmhd = () => {
    const result = Object.entries(KyHieuMauHoaDonMode).map(([key, value]) => {
      return {
        value,
        label: `${value} - ${t(`khmhdon_list.${value}`)}`,
      };
    });

    setData_khmhd(result || []);
  };

  return (
    <React.Fragment>
      <Modal
        size="xl"
        isOpen={isOpenModal}
        role="dialog"
        autoFocus={true}
        centered={true}
        className="exampleModal"
        toggle={toggleModal}
      >
        <div className="modal-content">
          <ModalHeader toggle={toggleModal}>
            {mode === invoiceSymbolModeList.CREATE_INVOICE_SYMBOL_DETAIL &&
              `${t("title.create")}`}
            {mode === invoiceSymbolModeList.VIEW_INVOICE_SYMBOL_DETAIL &&
              `${t("title.detail")}`}
            {mode === invoiceSymbolModeList.EDIT_INVOICE_SYMBOL_DETAIL &&
              `${t("title.edit")}`}
          </ModalHeader>
          {loadingDetail ? (
            <ModalBody>
              <LoadingFormNormal
                countInput="3"
                countButton="1"
                formClass="row-cols-1 row-cols-md-2"
                buttonClass="justify-content-end"
                buttonColClass="col-3"
              />
            </ModalBody>
          ) : (
            <React.Fragment>
              <ModalBody>
                <Row className="row-cols-1 row-cols-lg-2">
                  {controlFields.display.bu_code && (
                    <Col>
                      <FormGroup className="mb-3">
                        <Label htmlFor="bu_code">
                          {t("form.bu_code")}{" "}
                          <span className="text-danger">*</span>
                        </Label>
                        <input
                          disabled={controlFields.disabled.bu_code}
                          type="text"
                          className={`form-control ${formValidate(
                            errors,
                            touchedFields,
                            "bu_code"
                          )}`}
                          placeholder={t("placeholder.enter", {
                            title: t("form.bu_code"),
                          })}
                          {...register("bu_code")}
                        />
                        {errors.bu_code && (
                          <MessageFormValidate error={errors.bu_code.message} />
                        )}
                      </FormGroup>
                    </Col>
                  )}

                  {controlFields.display.khmhdon && (
                    <Col>
                      <FormGroup className="mb-3">
                        <Label htmlFor="khmhdon">
                          {t("form.khmhdon")}{" "}
                          <span className="text-danger">*</span>
                        </Label>
                        <Controller
                          control={control}
                          name="khmhdon"
                          render={({ field }) => (
                            <Select
                              {...field}
                              isDisabled={controlFields.disabled.khmhdon}
                              placeholder={t("placeholder.select", {
                                title: t("form.khmhdon"),
                              })}
                              options={data_khmhd}
                              classNamePrefix="select2-selection"
                            />
                          )}
                        />
                        {errors.khmhdon && (
                          <MessageFormValidate error={errors.khmhdon.message} />
                        )}
                      </FormGroup>
                    </Col>
                  )}

                  {controlFields.display.khhdon && (
                    <Col>
                      <FormGroup className="mb-3">
                        <Label htmlFor="khhdon">
                          {t("form.khhdon")}{" "}
                          <span className="text-danger">*</span>
                        </Label>
                        <Controller
                          control={control}
                          name="khhdon"
                          render={({ field: { onChange, name, value } }) => (
                            // A, B, C, D, E, G, H, K, L, M, N, P, Q, R, S, T, U, V, X, Y
                            <InputMask
                              mask="**"
                              value={value}
                              disabled={controlFields.disabled.khhdon}
                              className={`form-control ${formValidate(
                                errors,
                                touchedFields,
                                "khmhdon"
                              )}`}
                              onKeyDown={e => {
                                const charAllow = [
                                  "A",
                                  "B",
                                  "C",
                                  "D",
                                  "E",
                                  "G",
                                  "H",
                                  "K",
                                  "L",
                                  "M",
                                  "N",
                                  "P",
                                  "Q",
                                  "R",
                                  "S",
                                  "T",
                                  "U",
                                  "V",
                                  "X",
                                  "Y",
                                ];
                                if (
                                  value.replace("_", "").length === 4 &&
                                  (e.keyCode === 8 || e.keyCode === 46)
                                ) {
                                  e.preventDefault();
                                } else {
                                  if (
                                    charAllow.indexOf(e.key.toUpperCase()) ===
                                      -1 &&
                                    e.keyCode !== 8
                                  ) {
                                    e.preventDefault();
                                  }
                                }
                              }}
                              onChange={v => {
                                onChange(
                                  v.target.value.replace("_", "").toUpperCase()
                                );
                              }}
                            ></InputMask>
                          )}
                        />
                        {errors.khhdon && (
                          <MessageFormValidate error={errors.khhdon.message} />
                        )}
                      </FormGroup>
                    </Col>
                  )}
                  <Col>
                    <div className="d-flex" style={{ flexDirection: "column" }}>
                      <Label style={{ marginTop: "21px" }} className="d-flex">
                        <input
                          name="is_pos"
                          type="checkbox"
                          disabled={controlFields.disabled.khmhdon}
                          id="checkbox_isSaveInfoCustomer"
                          className="custom-control-input checkbox-isSaveInfoCustomer"
                          style={{
                            minWidth: "30px",
                            height: "17px",
                            marginTop: "0px",
                          }}
                          {...register("is_pos")}
                        />
                        <div className="text-info  fw-bold">
                          {t("form.isPos")}
                        </div>
                      </Label>

                      <Label className="d-flex">
                        <input
                          name="is_default"
                          type="checkbox"
                          disabled={controlFields.disabled.is_default}
                          id="checkbox_isSaveInfoCustomer"
                          className="custom-control-input checkbox-isSaveInfoCustomer"
                          style={{
                            minWidth: "30px",
                            height: "17px",
                            marginTop: "0px",
                          }}
                          {...register("is_default")}
                        />
                        <div className="text-primary fw-bold">
                          {" "}
                          Sử dụng mặc định
                        </div>
                      </Label>
                    </div>
                  </Col>
                </Row>
              </ModalBody>
              <ModalFooter>
                <Row className="justify-content-end">
                  {controlFields.display.btn_save && (
                    <Col className="col-auto">
                      <Button
                        color="primary"
                        className="btn-label"
                        type="button"
                        onClick={() => {
                          handleSubmit(onSubmit)();
                        }}
                        disabled={loadingUpdate || loadingCreate}
                      >
                        <i className="bx bx-save label-icon"></i>
                        {t("form.save")}
                      </Button>
                    </Col>
                  )}
                </Row>
              </ModalFooter>
            </React.Fragment>
          )}
        </div>
      </Modal>
    </React.Fragment>
  );
};

DetailInvoiceSymbol.propTypes = {
  isOpenModal: PropTypes.bool.isRequired,
  toggleModal: PropTypes.func.isRequired,
  dataDetail: PropTypes.object.isRequired,
  mode: PropTypes.string.isRequired,
  buCode: PropTypes.string.isRequired,
};

DetailInvoiceSymbol.defaultProps = {
  isOpenModal: false,
  dataDetail: {},
  mode: "",
  buCode: "",
};

export default DetailInvoiceSymbol;
